// extracted by mini-css-extract-plugin
module.exports = {"root":"ZoomImage_root__2yCuj","zoomBtn":"ZoomImage_zoomBtn__3wgQJ","modal":"ZoomImage_modal__1CeE-"};